import { componentStyle } from '@/styling/util/component-style.ts';
import type { ProgressSpinnerDesignTokens } from '@primeuix/themes/types/progressspinner';

export const progressSpinnerStyle = componentStyle<ProgressSpinnerDesignTokens>({
    root: {
        colorOne: '{primary.color}',
        colorTwo: '{primary.color}',
        colorThree: '{primary.color}',
        colorFour: '{primary.color}',
    },
});
